<div *customerFeatureToggle="CustomerFeature.SaveSearch" class="save-search-button-container">
  <button (click)="onSaveSearch($event)"
          class="save-search-button"
          data-automation-id="save-search-button">
    <span class="fas fa-search-plus icon" aria-hidden="true"></span>
    <span translate class="text">saveSearchButton</span>
  </button>
</div>
